import type { ReactElement, ReactNode } from "react";

import { AppFooter } from "@/app/layout/app-footer";
import { PublicHeader } from "@/app/layout/public-header";
import { PublicBrandHeader } from "@/shared/components/public-brand-header";
import { Card } from "@/shared/components/ui";

/**
 * Shared page chrome for the public `/pay` entry surfaces (locator landing and
 * guidance): public header, brand-blue main region with a centered white card
 * carrying the brand header, and the app footer. Every state a visitor can see
 * on these routes renders inside it so the surface never appears as bare
 * content on an unstyled page.
 */
export function PayPublicChrome({ children }: { children: ReactNode }): ReactElement {
  return (
    <div className="flex min-h-screen flex-col bg-background text-foreground">
      <PublicHeader />
      <main className="clm-page-gutter flex flex-1 items-center justify-center bg-clm-primary-blue py-12">
        <Card className="w-full max-w-lg border-0 bg-white px-2 py-8 shadow-md sm:px-8">
          <div className="px-6">
            <PublicBrandHeader className="mb-8" />
            {children}
          </div>
        </Card>
      </main>
      <AppFooter />
    </div>
  );
}
